import { useMantineTheme, Text } from "@mantine/core";
import { useCallback, useEffect, useRef, useState } from "react";
import { ReportProps } from "../../../../types/types";
import AceEditor from "react-ace";
import "./QueryEditor.css";
import Button from "@mui/material/Button";
import { useAuth } from "../../../../providers/AuthProvider";
import { commonPost } from "../../../../services/reportService";
import DataTable from "../../DataTable/DataTable";
import { popNotification } from "../../../kpi/setup/notification/notificationUtils";
import { X, Edit } from "tabler-icons-react";
import { ArrayUtils } from "../../../../utils/arrayUtils";
import { QueryAnalyser } from "./QueryAnalyser/QueryAnalyser";
import { popupType } from "../../../../types/types";
import { GenericPopUp } from "../../../popup/genericPopUp";
import { ChannelkartNetworkPost } from "../../../../services/networkService";

export function QueryEditor(props: ReportProps) {
  const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);
  const currentTheme = useMantineTheme();
  const QueryInfo = (props.currentReportComponent==="viewReport" && props.diffrentQueryForViewReportFlag === "no")?props.queryInfoViewReport:props.queryInfo;
  const [showDataTable, setShowDataTable] = useState<boolean>(false);
  const [readOnly, setreadOnly] = useState<boolean>(false);
  const [formValues, setFormValues] = useState([{ param: "", paramValue: "" }]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [openGenericModal, setOpenGenericModal] = useState(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [showGlobalFilters, setShowGlobalFilters] = useState<boolean>(false);

  const [genericMessage,setGenericMessage] = useState("");

  const paramLength = useRef(0);
  const viewMode = props.reportInfo.viewEditStatus === "VIEW" ? true : false;
  const queryComment = `# example select name,loginid from ck_user where loginid = '{{loginid}}';
# add parameter given below and test your query;`;
  var limit = 10;
  const comments = queryComment;
  const query =
    comments + "\n" + (QueryInfo.query ? QueryInfo.query : "");

  useEffect(() => {
    if (props.currentReportComponent === "viewReport") setShowDataTable(false);
  }, [props.diffrentQueryForViewReportFlag])

const[response, setResponse] = useState({});
  function prepareQuery(sql: string) {
    return sql
      .split("\n")
      .filter((line) => !line.startsWith("#"))
      .filter((line) => !line.startsWith("--"))
      .join("\n");
  }
  const openPopup = (message:string, type:popupType)=>{
    setPopupType(type)
    setGenericMessage(message)
    setOpenGenericModal(true)
  }
  function prepareParam(sql: string) {
    const regexp = /\{\{[^}]*}}/g;
    const paramSet = new Set(
      Array.from(sql.matchAll(new RegExp(regexp)), (m) =>
        m[0].substring(2, m[0].length - 2)
      )
    );
    QueryInfo.UIParams = [];
    let paramArray: object[] = [];
    paramSet.forEach((paramKey: string) => {
      var paramObj = { param: "", paramValue: "" };
      paramObj["param"] = paramKey;
      paramObj["paramValue"] = "";
      paramArray.push(paramObj);
    });
    QueryInfo.UIParams = paramArray;
  }

  const queryInfoBody = () => {
    const query = QueryInfo.query;
    const finalQuery = QueryInfo.query.includes("limit")
      ? query
      : query.includes(";")
      ? query.replace(";", "").concat(" limit " + limit)
      : query.concat(" limit " + limit);
    setParams();
    QueryInfo.queryInfoBody = {
      queryInfo: {
        name: QueryInfo.name,
        query: prepareQuery(finalQuery),
        language: "sql",
        implementation:
          "com.applicate.services.channelkart.querys.DynamicQueryExecutor",
        type: "Analytics",
        description: QueryInfo.description,
        enabled: readOnly,
      },
      params: QueryInfo.params,
    };
  };

  let setParams = () => {
    var obj: { [k: string]: any } = {};
    QueryInfo?.UIParams?.forEach((element) => {
      obj[element["param" as keyof typeof element]] =
        element["paramValue" as keyof typeof element];
    });
    QueryInfo.params = obj;
  };

  let handleChange = (i: number, e: React.ChangeEvent<HTMLInputElement>) => {
    let newFormValues = [...formValues];
    const eventName = e.target.name === "param" ? "param" : "paramValue";
    newFormValues[i][eventName] = e.target.value;
    setFormValues(newFormValues);
  };

  let addFormFields = (params: any) => {
    if (params) setFormValues(params);
    else setFormValues([...formValues, { param: "", paramValue: "" }]);
  };

  let removeFormFields = (i: any) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  let handleSubmit = (event: any) => {
    event.preventDefault();
    alert(JSON.stringify(formValues));
  };

  const getQueryResult = async (props: ReportProps): Promise<void> => {
    let url = "/v1/query/";
    queryInfoBody();
    try {
      let token = localStorage.getItem("token");
      let header = {};
      if(token){
        header = {internal_token: token};
      }
      let response = await ChannelkartNetworkPost(url,QueryInfo.queryInfoBody,header);
      QueryInfo.data = response.data;
      var dataLength: number = QueryInfo.data?.length ? QueryInfo.data.length : 0;
      if (dataLength > 0) {
        setShowDataTable(!showDataTable);
      } else
        popNotification(
          "Alert",
          "No data Found ! Try with differnt Query OR Param",
          "red",
          <X />
        );

    } catch (e) {
      if (e instanceof Error) {
        popNotification("Alert", e.message, "red", <X />);
        console.error(e.message);
      }
    }
  };

  const getAnalyseResult = async (): Promise<any> => {
    let url = "/v1/queryPerformanceDetail/";
    queryInfoBody();
     const requestBody = {
         queryInfoWithParam: QueryInfo.queryInfoBody,
      };
    try {
      let analyseData:any = await commonPost(url, requestBody, authContext);
      return analyseData;
          } catch (e: any) {
      openPopup(e?.response?.data?.message, "Error");
    }
  };
  useEffect(() => {
    paramLength.current = paramLength.current + 1;
  });

  const onChangeQuery = (event: any) => {
    (props.currentReportComponent==="viewReport" && props.diffrentQueryForViewReportFlag === "no")?props.queryInfoViewReport.query = prepareQuery(event):props.queryInfo.query=prepareQuery(event)
     prepareParam(QueryInfo.query);
     addFormFields(QueryInfo.UIParams);
     props.setReportState((currentState) => ({
      ...currentState,
      validationErrors: currentState.validationErrors.filter(er => er.property !== 'notAllowedAnalyseError')
    }))
    props.setQueryFlag({
      Warning:[],
      "Not Allowed" :["Please analyse your query again"]
    })
  };
  

useEffect(() => {
  onChangeQuery(query);
},[query]);

  
  const testQueryFunction = () => {
    if (!readOnly && !viewMode)
      popNotification("Alert", "Kindly click on Edit button", "red", <X />);
    else if(viewMode)
    popNotification("Oops!", "You are in View Mode", "blue", <X />);
  };
  const queryNameError =
    ArrayUtils.isNotEmpty(props.validationErrors) &&
    props.validationErrors
      .filter((error) => error.property === "queryNameError")
      .map((error) => error.message)[0];
  const queryValueError =
    ArrayUtils.isNotEmpty(props.validationErrors) &&
    props.validationErrors
      .filter((error) => error.property === "queryValueError")
      .map((error) => error.message)[0];
  const notAllowedAnalyseError =
    ArrayUtils.isNotEmpty(props.validationErrors) &&
    props.validationErrors
      .filter((error) => error.property === "notAllowedAnalyseError")
      .map((error) => error.message)[0];

   useEffect( ()=>{
      queryNameError && popNotification("Alert", queryNameError, "red",<X/>)
      queryValueError && popNotification("Alert", queryValueError, "red",<X/>)
      notAllowedAnalyseError && popNotification("Alert", notAllowedAnalyseError, "red",<X/>)
    },[queryNameError, queryValueError, notAllowedAnalyseError]);

  const displayFilters = () => {
    if(props.reportUI.globalFilter.selectedFilter.list.length > 0){
      setShowGlobalFilters(!showGlobalFilters);
    }
  }
  const handleAnalyse = async () => {
    const response = await getAnalyseResult();
    
  setResponse(response);
  
  props.setQueryFlag(response.features[0].explain.queryFlag);
    setShowModal(true);
  };
  const getColumnData = () =>{
    let columnData: any = [];
    if (props.currentReportComponent === "viewReport" && props.diffrentQueryForViewReportFlag === "no") {
      if (props.queryInfoViewReport.data) {
        columnData = Object.keys(props.queryInfoViewReport.data[0]).map((e: any) => { return { id: e, label: e } })
      }
    }
    else {
      if (props.queryInfo.data) {
        columnData = Object.keys(props.queryInfo.data[0]).map((e: any) => { return { id: e, label: e } })
      }
    }
    return columnData;
  }

  const getGlobalFilterRowData = () => {
    let rowData : any = [];
    rowData = props.reportUI.globalFilter.selectedFilter.list.map((e:any) => {return {"id" : e.id}})
    // rowData = props.reportUI.globalFilter.selectedFilter.list.map((e:any) => {return e.id})
    return rowData;
  }

  const getGlobalFilterColumnData = () => {
    let columnData: any = [];
    columnData = [{ id: 'id', label: 'Global Filters' }]
    return columnData;
  }


  return (
    <div>
      <div className="queryEditor-container">
      <GenericPopUp message={genericMessage}
      type={popupType}
      openGenericModal={openGenericModal}
      setOpenGenericModal={setOpenGenericModal} />
        
        <Edit
          size={80}
          strokeWidth={1}
          color="black"
          onClick={() => {
            setreadOnly(!viewMode);
          }}
          style={{ visibility: !readOnly && !viewMode ? "visible" : "hidden" }}
        />
        <AceEditor
          className="queryEditor-editor"
          aria-label="editor"
          mode="mysql"
          theme={
            currentTheme.colorScheme === "light" ? "tomorrow" : "solarized_dark"
          }
          wrapEnabled={true}
          name="editor"
          fontSize={16}
          minLines={15}
          maxLines={15}
          width="100%"
          height="100%"
          showPrintMargin={false}
          placeholder="write you query here..."
          editorProps={{ $blockScrolling: true }}
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            readOnly: !readOnly,
          }}
          value={query}
          onChange={onChangeQuery}
          onFocus={testQueryFunction}
        />
      </div>
      <div id="query-test-btn">
        <div>
          <Button
            variant="outlined"
            className="query-submit-btn"
            onClick={() => {
              getQueryResult(props);
            }}
          >
            Test Query
          </Button>
          <Button
            variant="outlined"
            className="query-submit-btn"
            onClick={() => addFormFields("")}
          >
            Add Params
          </Button>
          <Button variant="outlined"  className='query-submit-btn' onClick={handleAnalyse}>Analyse</Button>
          {/* <Button variant="outlined"  className='query-submit-btn' onClick={displayFilters}>Global filters</Button> */}
        </div>

        <div id="param-fields">
          <form onSubmit={handleSubmit}>
            {/* {   <Button className="button add" type="button" onClick={() => addFormFields('')}>Add Params</Button>  } */}
            {formValues.map((element, index) => (
              <div className="form-inline" key={index}>
                <input
                  type="text"
                  name="param"
                  value={element.param || ""}
                  onChange={(e) => handleChange(index, e)}
                  placeholder={element.param || ""}
                />
                <input
                  type="text"
                  name="paramValue"
                  value={element.paramValue || ""}
                  onChange={(e) => handleChange(index, e)}
                  placeholder="value"
                />
                {
                  <Button
                    type="button"
                    className="remove-button remove"
                    onClick={() => removeFormFields(index)}
                  >
                    Remove
                  </Button>
                }
              </div>
            ))}
          </form>
        </div>
      </div>
      <div>
{showModal && response && <QueryAnalyser showModal={showModal}
setShowModal={setShowModal}
response={response}/>}
</div>
      <div className="report-table">
        {showDataTable ? (
          <div className="report-table-with-data">
            <DataTable rowsData={ (props.currentReportComponent === "viewReport" && props.diffrentQueryForViewReportFlag === "no") ? props.queryInfoViewReport.data : props.queryInfo.data} columnData={getColumnData()} />
          </div>
        ) : (
          <></>
        )}
      </div>

      {/* {showError && 
               <pre>{JSON.stringify(props.analyseData, null, 2)}</pre>
          } */}
{showGlobalFilters && (
          <div>
            <DataTable rowsData={getGlobalFilterRowData()} columnData={getGlobalFilterColumnData()} />
          </div>
        )}

    </div>
  );
}
